export default __webpack_public_path__ + "static/media/sek.71eab7a6.webp";